import React from 'react';
import { trans, getPagePath } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { addDataLayerGAEvent } from '@utils/DataLayerGAHandler';

import './HomeFooter.scss';

const HomeFooter = () => {
  const handleGetStartedButton = () => {
    addDataLayerGAEvent('Tenant', 'clickBtn', 'mainFooterBtn');
  };
  return (
    <section className="home-footer_tenant__container">
      <div>
        <h2 className="home-footer_tenant__title">
          {trans('home.tenant.home-footer.title')}
        </h2>
        <div className="home-footer_tenant__subtitle">
          {trans('home.tenant.home-footer.subtitle')}
        </div>
      </div>
      <Button
        className="home-footer_tenant__button"
        size="big"
        color="complementary"
        href={getPagePath('externals.landlord-signup')}
        onClick={handleGetStartedButton}
      >
        {trans('home.tenant.home-footer.cta')}
      </Button>
    </section>
  );
};

export default HomeFooter;
